import React from 'react'
import MobileMenuContent from "./MobileMenuContent";
import { useState,useEffect } from 'react';
import YIcon from '../../assets/svgs/YIcon.svg'
import { useSelector } from 'react-redux';


const MobileMenu = () => {
  const [sidebar, setSidebar] = useState(false);
  const photoUserUrl = useSelector(state => state.userSessionControl);
  const handleImageClick = () => {
    const url = 'https://www.yolocoliving.com.br/';
    window.open(url, '_blank');
  };
  const toogleSidebar = () =>{
    setSidebar(!sidebar);
  }

  return (
    <>
      <div className="stylehome1 h0 mega-menu-wrapper">
        <div className="mobile-menu">
          <div className="header stylehome1">
            <div className="main_logo_home2 text-center">
              <img style={{width:'134px',height:'45px'}}
                className="nav_logo_img contain mt20"
                src={YIcon}
                alt="header-logo2.png"
                onClick={handleImageClick}
              />
              {/* <span className="mt20">FindHouse</span> */}
            </div>
            {/* main_logo_home2 */}
  
            <ul className="menu_bar_home2">
              <li className="list-inline-item list_s">
                <a href="https://proprietario.yolocoliving.com.br/" target=''>
                  <span className="flaticon-user color_primary_important"></span>
                 {/*  {photoUserUrl === null && <span className="flaticon-user color_primary_important"></span>}
                  {photoUserUrl !== null && <img style={{borderRadius:"30px",marginTop:"10px"}} className='width_28'  src={photoUserUrl} referrerPolicy="no-referrer" alt="" /> } */}
                </a>
              </li>
              <li
                className="list-inline-item"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasMenu"
                aria-controls="offcanvasMenu"
              >
                <a onClick={()=> toogleSidebar()}>
                  <span></span>
                </a>
              </li>
            </ul>
            {/* menu_bar_home2 */}
          </div>
        </div>
        {/* <!-- /.mobile-menu --> */}
  
        <div
          className={`offcanvas offcanvas-start ${ sidebar === true ? 'show' : ''}`}
          tabIndex="-1"
          id="offcanvasMenu"
          aria-labelledby="offcanvasMenuLabel"
          data-bs-scroll="true"
        >
          <MobileMenuContent toogleSidebar={toogleSidebar} />
        </div>
      </div>
    </>
    );
}

export default MobileMenu;